import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as ButtonComponent } from '@sezane/front-components';
import translate from '../../../../translate';
import useFormattedDate from '../../../../utils/hooks/useFormattedDate';
import CustomisationButton from './CustomisationButton';
const AddToBasketButton = ({ isPreorder, isAvailable, isInOtherBasket, isCustomisation, preorderDate, preorderDateEnd, ean, tracking, popinCrossSellPath, popinCrossSellProductEnabled, withTooltip = true, addedToCart, isLoading, id, }) => {
    let translation = 'front.product.index.cart_add';
    let addToBasketProps = {
        'data-cart-add-product': true,
    };
    if (tracking) {
        addToBasketProps['data-tracking'] = JSON.stringify(tracking);
    }
    if (popinCrossSellPath) {
        addToBasketProps['data-popin-cross-sell-path'] = popinCrossSellPath;
    }
    if (popinCrossSellPath && popinCrossSellProductEnabled) {
        addToBasketProps['data-popin-cross-sell-product-enabled'] = popinCrossSellProductEnabled;
    }
    if (addedToCart) {
        translation = 'front.product.index.added_to_cart';
        addToBasketProps = {
            disabled: true,
        };
    }
    else if (isPreorder && isInOtherBasket) {
        translation = 'front.product.index.in_other_basket_and_preorder_cart_add';
    }
    else if (isPreorder) {
        translation = 'front.product.index.preorder_cart_add';
    }
    else if (isInOtherBasket) {
        translation = 'front.product.index.in_other_basket';
        addToBasketProps = {
            disabled: true,
        };
    }
    const formattedPreorderDate = useFormattedDate(preorderDateEnd) ?? preorderDate;
    const label = translate(translation, { date: formattedPreorderDate });
    const Button = isCustomisation && isAvailable && !addedToCart && ean ? (_jsx(CustomisationButton, { ean: ean, children: label })) : (_jsx(ButtonComponent, { ...addToBasketProps, type: "button", id: id, className: "c-tooltip__trigger js-add-cart-button", "aria-describedby": "tooltip-expedition", isLoading: isLoading, fullWidth: true, children: label }));
    if (isPreorder && withTooltip && !addedToCart) {
        return (_jsxs("span", { className: "c-tooltip c-tooltip--secondary u-w-100", children: [Button, _jsx("span", { id: "tooltip-expedition", className: "c-tooltip__bubble c-tooltip__bubble--multiline-full c-tooltip__bubble--spacing", role: "tooltip", dangerouslySetInnerHTML: {
                        __html: translate('front.product.index.preorder_text', {
                            date: formattedPreorderDate,
                        }),
                    } })] }));
    }
    return Button;
};
export default AddToBasketButton;
